// Server-only variables (SEC-4), read through getters so each value is read when it is used, as before.
export const serverEnv = {
    get appBaseUrl() {
        return process.env.APP_BASE_URL
    },
    get auth0Audience() {
        return process.env.AUTH0_AUDIENCE
    },
    get auth0BaseUrl() {
        return process.env.AUTH0_BASE_URL
    },
    get auth0ClientId() {
        return process.env.AUTH0_CLIENT_ID
    },
    get auth0ClientIdMachineToMachine() {
        return process.env.AUTH0_CLIENT_ID_MACHINE_TO_MACHINE
    },
    get auth0ClientSecret() {
        return process.env.AUTH0_CLIENT_SECRET
    },
    get auth0ClientSecretMachineToMachine() {
        return process.env.AUTH0_CLIENT_SECRET_MACHINE_TO_MACHINE
    },
    get auth0DevBaseUrl() {
        return process.env.AUTH0_DEV_BASE_URL
    },
    get auth0Domain() {
        return process.env.AUTH0_DOMAIN
    },
    get auth0Scope() {
        return process.env.AUTH0_SCOPE
    },
    get auth0Secret() {
        return process.env.AUTH0_SECRET
    },
    get encryptionKey() {
        return process.env.ENCRYPTION_KEY
    },
    get jwtSecretKey() {
        return process.env.JWT_SECRET_KEY
    },
    get pennylaneBaseUrl() {
        return process.env.PENNYLANE_BASE_URL
    },
    get testPurpose() {
        return process.env._TEST_PURPOSE
    }
}
